import { loadableWithFallback } from '@vision/ui/utils';
import type { TrendChart2Props } from './TrendChart2';

export const TrendChart2 = loadableWithFallback<TrendChart2Props>(() => import('./TrendChart2'));
